import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MyCompanyPage, OrganizationPageTabs } from 'pages/app/organization-page/OrganizationPage'

const organizationSearchSchema = z.object({
  tab: z.nativeEnum(OrganizationPageTabs).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/app/organisation')({
  validateSearch: organizationSearchSchema,
  component: MyCompanyPage,
})
